<div class="custom-control custom-checkbox">
  <input  type="checkbox" name="{{name}}" [checked]="model"
    [value]="value" 
    class="custom-control-input" 
    (change)="select($event)"
    id="{{id}}" >
  <label class="custom-control-label" for="{{id}}">{{label}}</label>
</div>